import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Video, Mail } from 'lucide-react';

const BuyerInteractionRequestModal = ({
  open, onOpenChange, interactionType, interactionMessage, setInteractionMessage,
  selectedBooth, user, createInteraction, t,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader className="pb-2">
          <DialogTitle className="text-lg">{interactionType === 'call_request' ? t('dashboard.request_to_talk') : t('dashboard.request_documentation')}</DialogTitle>
          <DialogDescription className="text-sm">{interactionType === 'call_request' ? t('dashboard.rep_will_connect') : t('dashboard.request_product_info')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="bg-slate-50 rounded-lg p-2"><p className="font-medium text-sm">{selectedBooth?.company_name}</p></div>
          <div>
            <Label className="text-sm">{t('dashboard.message_optional')}</Label>
            <Textarea value={interactionMessage} onChange={(e) => setInteractionMessage(e.target.value)}
              placeholder={interactionType === 'call_request' ? t('dashboard.what_to_discuss') : t('dashboard.what_info_looking')} rows={2} className="text-sm" />
          </div>
          <p className="text-xs text-slate-500">{t('dashboard.info_shared', { name: user?.name, email: user?.email })}</p>
        </div>
        <DialogFooter className="pt-2">
          <Button size="sm" variant="outline" onClick={() => onOpenChange(false)}>{t('common.cancel')}</Button>
          <Button size="sm" onClick={createInteraction}>
            {interactionType === 'call_request' ? (<><Video className="h-4 w-4 mr-1" /> {t('dashboard.join_queue')}</>) : (<><Mail className="h-4 w-4 mr-1" /> {t('dashboard.send_btn')}</>)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BuyerInteractionRequestModal;
